import { type List, Record, type RecordOf } from 'immutable';

import type { BaseResource, QcsSyncResourceStore } from '../core/resourceStoreTypes';

export const SUBSCRIPTIONS_REDUCER_KEY = 'subscriptionsStore' as const;

export type BundleInfo = {
  sku?: string;
  renewalSku?: string;
  name?: string;
  txnId?: string;
};

export type RenewalFrequency = string;

export type SupportedDatasetPlatforms = List<string> | string[];

export type SubscriptionProps = BaseResource & {
  createdAt?: string;
  modifiedAt?: string;
  userModifiedAt?: string;
  productName?: string;
  productLineName?: string;
  productLineUriName?: string;
  tierName?: string;
  tierUriName?: string;
  active?: boolean;
  autoRenew?: boolean;
  userId?: string;
  effectiveAt?: string;
  expireAt?: string;
  expireOn?: string;
  inactiveAt?: string;
  partnerExpireAt?: string;
  currentTerm?: string;
  updatingPaymentMethodWillAutorenew?: boolean;
  supportedDatasetPlatforms?: SupportedDatasetPlatforms;
  isInTrialPeriod?: boolean;
  renewalFrequency?: RenewalFrequency;
  merchant?: string;
  isInGracePeriod?: boolean;
  isCoTerminus?: boolean;
  coTermProductLines?: string[];
  bundleInfo?: BundleInfo;
  additionalEntitlements?: string[];
  allEntitlements?: string[];
  subscriptionExternal?: boolean;
  remindLater?: boolean;
};

export type SubscriptionRecord = RecordOf<SubscriptionProps>;

export type SubscriptionsStore = QcsSyncResourceStore<SubscriptionProps>;

export type UpdateSubscriptionRenewalFrequencyPayload = BaseResource & {
  productLineUriName?: string;
  renewalFrequency?: RenewalFrequency;
};

export const mkSubscription = Record<SubscriptionProps>({
  id: undefined,
  clientId: undefined,
  isDeleted: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  userModifiedAt: undefined,
  productName: undefined,
  productLineName: undefined,
  productLineUriName: undefined,
  tierName: undefined,
  tierUriName: undefined,
  active: undefined,
  autoRenew: undefined,
  userId: undefined,
  effectiveAt: undefined,
  expireAt: undefined,
  expireOn: undefined,
  inactiveAt: undefined,
  partnerExpireAt: undefined,
  currentTerm: undefined,
  updatingPaymentMethodWillAutorenew: undefined,
  supportedDatasetPlatforms: undefined,
  isInTrialPeriod: undefined,
  renewalFrequency: undefined,
  merchant: undefined,
  isInGracePeriod: undefined,
  isCoTerminus: undefined,
  coTermProductLines: undefined,
  bundleInfo: undefined,
  additionalEntitlements: undefined,
  allEntitlements: undefined,
  subscriptionExternal: undefined,
  remindLater: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [SUBSCRIPTIONS_REDUCER_KEY]: SubscriptionsStore;
  }
}
